import { type ReactNode } from "react"
import { useAuth } from "../lib/auth-context"
import { LoginPage } from "../pages/login"
import { Spinner } from "./ui"

export function AuthGate({ children }: { children: ReactNode }) {
  const { user, isAdmin, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-muted">
        <Spinner size={32} />
      </div>
    )
  }
  if (!user || !isAdmin) return <LoginPage />

  return <>{children}</>
}
